import { useRouteError } from 'react-router';
import { Center } from '@astryxdesign/core/Center';
import { EmptyState } from '@astryxdesign/core/EmptyState';
import { Button } from '@astryxdesign/core/Button';

/** Last-resort error screen (e.g. a chunk failed to load after a new deploy). */
export function RouteError() {
  const error = useRouteError();
  console.error(error);
  return (
    <Center minHeight="100dvh" padding={6}>
      <EmptyState
        headingLevel={1}
        title="Что-то пошло не так"
        description="Обновите страницу. Если ошибка повторится — позвоните в студию."
        actions={<Button label="Обновить" variant="primary" onClick={() => window.location.reload()} />}
      />
    </Center>
  );
}
